var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeptagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8184 2.04063L24.8184 2.04061C24.9328 1.98646 25.0673 1.98646 25.1816 2.04061L25.1817 2.04063L44.1033 11.0003C44.1033 11.0003 44.1033 11.0003 44.1033 11.0003C44.2169 11.0541 44.2923 11.152 44.3173 11.2598L44.3174 11.26L48.9906 31.392C49.0156 31.4997 48.9902 31.6145 48.9169 31.7049L49.5994 32.2584L48.9169 31.7049L35.823 47.8496C35.7481 47.9418 35.6303 48 35.5008 48H14.4993C14.3697 48 14.2519 47.9417 14.1772 47.8497L1.08325 31.7049L1.08311 31.7048C1.00971 31.6143 0.984402 31.4995 1.00934 31.3921L0.0973968 31.1804L1.00934 31.3921L5.6826 11.26C5.70767 11.152 5.78321 11.054 5.89672 11.0003L24.8184 2.04063Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeptagon);
export default __webpack_public_path__ + "static/media/heptagon.13dd5991fcafe3712f52bf16ba77baf7.svg";
export { ForwardRef as ReactComponent };